import { Music, Users, Calendar, Search, Sparkles, Building2 } from 'lucide-react';
import SEOLandingPage from '../../components/seo/SEOLandingPage';

export default function MusikerFindenZuerich() {
  return (
    <SEOLandingPage
      title="Musiker finden in Zürich | jamnation - Zürcher Musikszene"
      description="Finde die besten Musiker in Zürich. Gitarristen, Schlagzeuger, Bassisten, Sänger und mehr. Entdecke die pulsierende Zürcher Musikszene auf jamnation."
      h1="Musiker finden in Zürich"
      heroText="Tauche ein in die pulsierende Musikszene von Zürich. Finde talentierte Musiker für deine Band, dein Studio-Projekt oder Live-Auftritte in der grössten Schweizer Stadt."
      keywords={[
        'musiker finden zürich',
        'musiker suchen zürich',
        'band musiker zürich',
        'gitarrist zürich',
        'schlagzeuger zürich',
        'bassist zürich',
        'sänger zürich',
        'musikszene zürich',
        'studio musiker zürich',
      ]}
      locationName="Zürich & Agglomeration"
      ctaButtons={[
        {
          text: 'Zürcher Musiker entdecken',
          link: '/musicians',
          primary: true,
        },
        {
          text: 'Zürcher Bands',
          link: '/bands',
        },
      ]}
      features={[
        {
          icon: Building2,
          title: 'Grösste Musikszene',
          description:
            'Zürich bietet die grösste und vielfältigste Musikszene der Schweiz. Finde Musiker aus allen Stadtkreisen und der ganzen Agglomeration.',
          link: '/musicians',
        },
        {
          icon: Sparkles,
          title: 'Professionelles Netzwerk',
          description:
            'Von Studio-Musikern bis zu Live-Performern – in Zürich findest du hochqualifizierte Musiker für professionelle Projekte.',
          link: '/musicians',
        },
        {
          icon: Music,
          title: 'Jedes Genre',
          description:
            'Rock, Pop, Electronic, Jazz, Hip-Hop, Classical – Zürichs Musikszene deckt alles ab. Finde Musiker für deinen Stil.',
          link: '/musicians',
        },
        {
          icon: Calendar,
          title: 'Zürcher Live-Szene',
          description:
            'Von der Roten Fabrik bis zum Kaufleuten – sieh dir an, wo Zürcher Bands live auftreten und vernetze dich mit der Szene.',
          link: '/agenda',
        },
        {
          icon: Search,
          title: 'Intelligente Suche',
          description:
            'Finde schnell den perfekten Musiker nach Instrument, Genre, Erfahrung und Stadtteil. Präzise Filter für beste Resultate.',
          link: '/musicians',
        },
        {
          icon: Users,
          title: 'Aktive Community',
          description:
            'Hunderte aktive Musiker in Zürich warten darauf, mit dir zu jammen. Werde Teil der grössten Musikerplattform.',
          link: '/become-musician',
        },
      ]}
      teaserSection={{
        title: 'Was du auf jamnation alles tun kannst',
        description:
          'jamnation ist mehr als nur eine Musikersuche. Hier kannst du deine Band präsent machen und dich mit der ganzen Zürcher Musikszene vernetzen.',
        items: [
          'Erstelle ein Profil für deine Band und zeige, was ihr drauf habt',
          'Veröffentliche bevorstehende Konzerte und erreiche mehr Publikum',
          'Teile Geschichten und Erlebnisse aus dem Bandalltag',
          'Lade Hörproben und Songs hoch, damit Fans deine Musik entdecken',
          'Vernetze dich mit anderen Musikern und Bands aus der Region',
          'Werde als Band für Events und private Feiern gebucht',
        ],
      }}
      seoTeaser={{
        title: 'Zürichs Musikszene auf einen Blick',
        description:
          'Als grösste Stadt der Schweiz bietet Zürich eine unvergleichbare Vielfalt an musikalischem Talent. Ob du einen Gitarristen für deine Band suchst, einen Schlagzeuger für Studio-Aufnahmen brauchst oder als Sängerin mit erfahrenen Musikern zusammenarbeiten möchtest – auf jamnation findest du Musiker aus allen Genres und Erfahrungsstufen. Von Kreis 5 über Wiedikon bis nach Oerlikon: Die Zürcher Musikszene ist lebendig und vernetzt. Nutze unsere Plattform, um gezielt nach Instrument, Genre und Standort zu suchen, Soundbeispiele anzuhören und direkt Kontakt aufzunehmen. Ob professionelles Studio-Projekt, Live-Band für Clubs wie Mascotte und Dynamo oder entspannte Jam-Sessions – hier findest du die richtigen Musiker für dein Vorhaben.',
      }}
      faqItems={[
        {
          question: 'Wie finde ich professionelle Musiker in Zürich?',
          answer:
            'Nutze die Erfahrungsfilter in der Suche und schau dir die Profile mit Soundbeispielen und bisherigen Projekten an. Viele Zürcher Profi-Musiker sind auf jamnation aktiv.',
        },
        {
          question: 'Gibt es auch Musiker für Studio-Aufnahmen in Zürich?',
          answer:
            'Ja! Viele Musiker in Zürich bieten ihre Dienste für Studio-Sessions an. Schreib in deiner Anfrage einfach, dass du für Aufnahmen suchst.',
        },
        {
          question: 'Kann ich nach Stadtteilen in Zürich filtern?',
          answer:
            'Die Standortsuche ermöglicht es dir, nach bestimmten Bereichen in Zürich und Umgebung zu suchen, damit du Musiker in deiner Nähe findest.',
        },
        {
          question: 'Welche Musikstile sind in Zürich am stärksten vertreten?',
          answer:
            'Zürich bietet alles: Electronic und Hip-Hop sind sehr stark, aber auch Rock, Indie, Jazz und Pop haben eine grosse Szene. Du findest Musiker für jeden Stil.',
        },
        {
          question: 'Ist jamnation auch für internationale Projekte geeignet?',
          answer:
            'Absolut! Viele Zürcher Musiker sind mehrsprachig und arbeiten an internationalen Projekten. Die Stadt zieht Talente aus aller Welt an.',
        },
      ]}
    />
  );
}
